import Account from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialConfigState = {
  modelId: null,
  type: 'account',
  value: ''
}

export default {
  namespaced: true,
  state: {
    accounts: [],
    filteredCollection: [],
    current: new Account(),
    currentConfig: initialConfigState
  },
  getters: {
    getCollection: state => state.accounts,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.accounts.find(account => account.id === id),
    getCurrent: state => state.current,
    getCurrentConfig: state => state.currentConfig
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/accounts?include=modules,themes,plugins',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((account) => {
            commit('addAccountToCollection', { accountData: account })
            return getters.getById(account.id)
          })

          commit('addCustomerToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/accounts',
        data: model.getJSON()
      }).then((res) => {

        commit('addAccountToCollection', { accountData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/accounts/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addAccountToCollection', { accountData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/accounts/' + id
      }).then((res) => {

        commit('removeAccountFromCollection', id)

        return res
      })
    },
    getConfig ({ commit }, payload) {
      return this.dispatch('get', {
        path: 'v1/configs/account/' + payload.modelId
      }).then((config) => {
        if (config.message) {
          if (config.message === 'Could not find the resource.') {
            // create new config
            return this.dispatch('updateConfig', {
              modelId: payload.modelId,
              value: ''
            }).then(() => {
              return this.dispatch('getConfig', {
                modelId: payload.modelId
              }).then((res) => {
                return res
              })
            })
          }

          throw config.message

        } else {
          const data = deepGet(config, 'body.data.value')
          const commitData = data && (data.length > 0 || typeof data === 'object') ? data : initialConfigState.value
          commit('updateCurrentConfig', commitData)
          return commitData
        }
      })
    },
    updateConfig (store, payload) {
      return this.dispatch('post', {
        path: 'v1/configs',
        data: {
          type: 'account',
          modelId: payload.modelId,
          value: payload.value
        }
      })
    }
  },
  mutations: {
    addAccountToCollection(state, { accountData, opts }) {
      addToCollection(this, state.accounts, accountData, Account, opts)
    },
    addCustomerToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeAccountFromCollection(state, accountId) {
      const index = state.accounts.findIndex(el => el.id === accountId)

      if (index === -1) {
        console.warn(`Could not find/delete account ${accountId}`)
        return
      }

      state.accounts.splice(index, 1)
    },
    clearCollection(state) {
      state.accounts = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, account) {
      state.current = account
    },
    resetCurrent (state) {
      state.current = new Account()
    },
    updateCurrentConfig (state, data) {
      state.currentConfig.value = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/account/store.js